"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const Slide_vue_1 = tslib_1.__importDefault(require("../Slide.vue"));
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const ChallengeType_1 = require("../../enums/ChallengeType");
const AuthenticationFactor_1 = require("../../enums/AuthenticationFactor");
const SlideHeader_vue_1 = tslib_1.__importDefault(require("../SlideHeader.vue"));
exports.default = vue_1.default.extend({
    name: 'one-time-code',
    data: () => {
        return {
            oneTimeCode: '',
            resendingCode: false,
            navigatingBack: false,
            canResendCode: true,
            clearError: false,
        };
    },
    props: {},
    computed: {
        hasError() {
            return (!this.$data.clearError && this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Success &&
                this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Unknown);
        },
        errorText() {
            return this.getSiteText(`ChallengeStatus.${this.$store.state.challengeStatus}`);
        },
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        codeSentText() {
            const currentChallenge = this.$store.state.currentChallenge;
            let codeSentText = '';
            if (currentChallenge.AuthenticationFactorValue === AuthenticationFactor_1.AuthenticationFactor.EmailCode) {
                codeSentText = this.getSiteText('CodeStepup.Verify.Email.CodeSent', [
                    currentChallenge.Destination.MaskedAddress.toLowerCase(),
                ]);
            }
            else if (currentChallenge.AuthenticationFactorValue === AuthenticationFactor_1.AuthenticationFactor.SmsCode ||
                currentChallenge.AuthenticationFactorValue === AuthenticationFactor_1.AuthenticationFactor.VoiceCode) {
                const lastDigits = currentChallenge.Destination.MaskedAddress.slice(-3);
                codeSentText = this.getSiteText('CodeStepup.Verify.Phone.CodeSent', [lastDigits]);
            }
            else if (currentChallenge.AuthenticationFactorValue === AuthenticationFactor_1.AuthenticationFactor.Unknown &&
                currentChallenge.Destination.MaskedAddress === 'Manual') {
                codeSentText = this.getSiteText('CodeStepup.Verify.ManualMfa.CodeSent');
            }
            return codeSentText;
        },
        resendButtonText() {
            if (this.isManualMfa) {
                return '';
            }
            return this.canResendCode ?
                this.getSiteText('CodeStepup.Verify.ResendCode') :
                this.getSiteText('CodeStepup.Verify.CodeSent');
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge || this.$store.getters.isSubmittingAuthenticatedModel;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        codeEntryHelperText() {
            if (this.isManualMfa) {
                return '';
            }
            const currentChallenge = this.$store.state.currentChallenge;
            return this.getSiteText('StepUp.OneTimeCode.DisplayInput.HelperText', [currentChallenge.MinutesToLive]);
        },
        isManualMfa() {
            const currentChallenge = this.$store.state.currentChallenge;
            if (currentChallenge.AuthenticationFactorValue === AuthenticationFactor_1.AuthenticationFactor.Unknown &&
                currentChallenge.Destination.MaskedAddress === 'Manual') {
                return true;
            }
            return false;
        },
    },
    mounted() {
        this.$el.querySelector('#txt_OTP').focus();
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        oneTimeCodeUpdated(value) {
            this.$data.oneTimeCode = value;
        },
        onFocus() {
            this.$data.clearError = true;
        },
        async submitForm() {
            if (this.submitting) {
                return;
            }
            this.$data.clearError = false;
            const challenge = {
                ...this.currentChallenge,
                ValidationKey: this.$data.oneTimeCode,
                // add remember device settings
                RememberDevice: this.$store.getters.rememberDevice,
                DeviceName: this.$store.getters.deviceName,
            };
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            // submit the challenge
            await this.$store.dispatch('submitChallenge', challenge);
            // reset code if there are errors
            if (this.hasError) {
                this.oneTimeCodeUpdated('');
            }
        },
        async navigateBack() {
            if (this.navigatingBack) {
                return;
            }
            this.navigatingBack = true;
            this.oneTimeCode = '';
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            await this.$store.dispatch('goToPreviousChallenge');
            this.navigatingBack = false;
        },
        async resendCode() {
            if (this.resendingCode) {
                return;
            }
            this.resendingCode = true;
            const challenge = {
                ...this.currentChallenge,
                ChallengeTypeValue: ChallengeType_1.ChallengeType.OneTimeCodeDestination,
            };
            await this.$store.dispatch('submitChallenge', challenge);
            this.resendingCode = false;
            // reset code after resending it, disable the resend button and create timer to enable it after 1 minute
            this.oneTimeCodeUpdated('');
            this.canResendCode = false;
            setTimeout(() => this.canResendCode = true, 60000);
        },
    },
    components: {
        IsotopeSlide: Slide_vue_1.default,
        SlideHeader: SlideHeader_vue_1.default,
    },
});
